import React, { useEffect } from 'react';
import { Box } from 'grommet';
import { useDispatch } from 'react-redux';
import { removeAuthToken } from 'granite-admin/core/controllers/dashboardHeader';
import Loader from 'granite-admin/core/components/Loader';
import userAPI from 'granite-admin/accounts/gateways/user-api';
const ssoLogoutURL = process.env.REACT_APP_SSO_LOGOUT_URL;
const SsoLogout = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    const logout = async () => {
      let {
        data
      } = await userAPI.ssoLogout(ssoLogoutURL);
      window.location = data.url;
      removeAuthToken();
      dispatch({
        type: 'accounts/user/RESET_STATE'
      });
    };
    logout();
  }, [dispatch]);
  return /*#__PURE__*/React.createElement(Box, {
    align: "center",
    height: "100%",
    justify: "center"
  }, /*#__PURE__*/React.createElement(Loader, null));
};
export default SsoLogout;